export enum MessageType {

    TEXT = '0',
    TABLE = "1",
    LINE = "2",
    BAR = "3",
    PIE = "4"

}

export interface MessageItem {
    role: "ai" | "user",
    isStreaming: boolean,
    statusText: string,
    content: string,
    msgType: string,
    chartData: any,
    field: any,
    title: string,
    subTitle: string
}